import { render, staticRenderFns } from "./SystemReports.vue?vue&type=template&id=771413b0"
import script from "./SystemReports.vue?vue&type=script&lang=js"
export * from "./SystemReports.vue?vue&type=script&lang=js"
import style0 from "./SystemReports.vue?vue&type=style&index=0&id=771413b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports